import React from 'react';
import { View } from 'react-native';

const DotIndicator = ({
  size = 3,
  color = 'Time/Light/Scheduled',
  hasOutline = true,
  outlineColor = 'Background/Light/Chart No Trans',
  outlineWidth = 1,
  scale,
  C,
  style,
}) => {
  const scaledSize = scale(size, false);
  const scaledOutline = scale(outlineWidth, false);
  const outerSize = scaledSize + scaledOutline;

  return (
    <View
      style={[
        {
          width: outerSize,
          height: outerSize,
          borderRadius: outerSize / 2,
          backgroundColor: hasOutline ? C(outlineColor) : 'transparent',
          justifyContent: 'center',
          alignItems: 'center',
        },
        style,
      ]}
    >
      <View
        style={{
          width: scaledSize,
          height: scaledSize,
          borderRadius: scaledSize / 2,
          backgroundColor: C(color),
        }}
      />
    </View>
  );
};

export default DotIndicator;
